<template>
    <div :id="this.$route.name">
        <card back> 
            <template v-slot:header>
            <h4 class="d-inline">خرید سرویس جدید</h4>
            <hr>    
            </template>
            <template v-slot:content>
                <form>
                    <div class="row">
                        <div class="col-md-3 col-12">
                            <small id="LblOnlineSell">انتخاب سرویس</small>
                            <SearchableCombo :edit="false" :grp="0" :code="null" 
                                :rownumintable="3" :defaultvalue="DataAxios.TblProductsId"  @ResultCombo="GetResultOnlineSell"
                                :action="'TblCrmCombo/GetProductOnlineSell'" :method="'POST'" :idinput="'OnlineSell'"
                                :keyItem="'OnlineSell'" :disabled="false" >
                            </SearchableCombo>
                        </div>
                        <div class="col-md-3 col-12 ">
                            <small id="LblAmount">مبلغ قابل پرداخت </small>
                            <input dir="ltr"  type="text"  class="form-control required" id="txtAmount" v-model="Amount" tabindex="1" disabled/>
                        </div>
                        <div class="col-md-4 col-12 mt-4 h4">
                            <small>مبلغ پرداخت با احتساب مالیات و ارزش افزوده :</small>
                        </div>
                        <div class="col-md-2 col-12 h4 text-left mt-4">
                            <small>{{$Comma3ragham(MablagKol)}} ريال</small>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-3 col-12 " v-if="false">
                            <small id="LblCodeTakhfif">کد(اختیاری) : </small>
                            <input dir="ltr"  type="text"  class="form-control " id="txtCodeTakhfif" v-model="CodeTakhfif" tabindex="2" />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6 col-12 mt-5">
                            <payment @GatewayCode="Get_GatewayCode" @IsFix="FixAmount">
                                <template v-slot:ContentButtonPayment>
                                    <button  class="btn btn-success btn-block" @click.prevent="submit" :disabled="MablagKol==0 ? true : false " >واریز {{$Comma3ragham(MablagKol)}} ريال</button>
                                </template>
                                </payment>
                        </div>
                        
                    </div>
                </form>
            </template>
        </card>
    </div>
</template>
<script>
import Card from '@/components/Card/Card.vue'
 import SearchableCombo from "@/components/Combo/SearchableCombo.vue";
import Payment from "../Payment/Payment.vue";

export default {
  components: { Card, SearchableCombo, Payment },
    data(){
        return{
            DataAxios:{},
            Amount:0,
            GatewayCode:null,
            FixVariz:null,
            GetMablagh:null,
            productName:'',
            MablagKol:0,
            CodeTakhfif:'0'
        }
    },
    methods:{
        Get_GatewayCode(val) {
      this.GatewayCode = val
    },
    FixAmount(val) {
      this.FixVariz = val
    },
        GetResultOnlineSell(data){
            if(data.id!=null){
            this.DataAxios.TblProductsId=data.id
            this.productName=data.element.name
            this.Amount=this.$Comma3ragham(data.element.amount)
            this.MablagKol=Math.ceil(Number(data.element.amount) *0.1) +Number(data.element.amount)
            // var Mab = this.Amount.replace(/,/g, '')
            //     Mab = this.$b_ToPersianNumber(Mab)
            //     this.GetMablagh =this.$Comma3ragham(Mab) + ' ریال '
            }

        },
        submit(){
            if(Number(this.Amount.replace(/,/g, ""))>0){
                this.GoPayment();
            }else{
                this.$mySweetDefault("عملیات ناموفق","سرویسی برای خرید انتخاب نشده است","error",2500);
                return;
            }
        },
        GoPayment(){
            try {
                var DataAxios_Payment = {
                ArryfildValue: '',
                Method: 'Post',
                Action: 'Payment',
                Token: this.$session.get('Token'),
                }
                var ModelPayment = {
                    tblGatewayId: this.GatewayCode + '',
                    tblProductId:this.DataAxios.TblProductsId,
                    tblCustomerId:this.$session.get('CustomerInfo')==undefined ? 0 : this.$session.get('CustomerInfo').Id,
                    Amount: this.MablagKol,
                    Des: 'خرید سرویس' + this.productName,
                    counter:this.$route.query.counter != undefined ?this.$route.query.counter : '',
                    CodeTakhfif:this.CodeTakhfif
                }
                DataAxios_Payment.ArryfildValue = ModelPayment

                this.$PostData(DataAxios_Payment).then((data) => {
                if (data.success) {
                    window.location = data.responseUrl
                } else {
                    if (data.msg) {
                    this.$mySweetDefault('اطلاع رسانی', data.msg, 'warning', 3500)
                    } else {
                    this.$mySweetDefault('خطا', data.responsetxt, 'error', 2000)
                    this.$store.state.loadingRender = false
                    }
                }
                })
            } catch (error) {
                this.$store.state.loadingRender = false
            }
        }
    },
    computed:{
   
    },
    mounted(){
        if(this.$route.query.costcode!=undefined){
            this.$store.state.counterSharj=this.$route.query.counter
        }else{
            this.$mySweetDefault("عملیات ناموفق","برای خرید شارژ پیامک از طریق نرم افزار اقدام نمایید","error",2500);
            this.$router.push({name: 'Dashboard',})
        }
        
    }
}
</script>
<style scoped>

</style>